
define('ldsh!modules/page_generator/templates/variant_item', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<a href="javascript:void(0)">\n  <span class="ed-icon ' +
((__t = ( platformIcon )) == null ? '' : __t) +
'"></span>\n  ' +
__e( name ) +
'\n</a>\n';

}
return __p
};});

